export const translations = {
	'Datasource single graph': {
		no: 'Datakilde enkeltgraf',
	},
	'General': {
		no: 'Generelt',
	},
	'Datasources': {
		no: 'Datakilder',
	},
	'Datasource': {
		no: 'Datakilde',
	},
	'Datasource row': {
		no: 'Datakilde rad',
	},
	'Time column': {
		no: 'Tidskolonne',
	},
	'Metric row': {
		no: 'Metrikkrad',
	},
	'Color type': {
		no: 'Fargetype',
	},
	'Gradient direction': {
		no: 'Gradientretning',
	},
	'Start color': {
		no: 'Startfarge',
	},
	'End color': {
		no: 'Sluttfarge',
	},
};
